export default __webpack_public_path__ + "logo.eda9e928941e23c62f88571a5c45eb35.svg";